<template>
<v-footer height="100" width="auto" dark
    padless>
    <v-card
      class="indigo lighten-1 white--text text-center">
      <v-card>
          <v-card-text>
            <!-- <v-btn
            v-for="icon in icons"
            :key="icon"
            class="mx-4"
            icon
            >
              <v-icon size="30px">
                {{ icon }}
              </v-icon>
            </v-btn> -->
          </v-card-text>

          <v-row >
            <v-col cols="12" align-self="center" sm="12" md="4">
              <v-card-text class="white--text pt-0 class=text-center">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.5717919322865!2d-79.53644838582863!3d9.011489991745687!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8faca9f7d368acc5%3A0x8e48a2a6902b75e0!2sINNUVEX!5e0!3m2!1ses-419!2spa!4v1616971914446!5m2!1ses-419!2spa"
                    width="auto"
                    height="200"
                    style="border:0;"
                    allowfullscreen=""
                    loading="lazy">
                </iframe></v-card-text>
            </v-col>
            <v-col cols="12" sm="12" md="4">

              <div class="text-justify">
                <v-list-item>
                  <v-list-item-icon>
                    <v-btn
                      text
                      href="https://g.page/innuvex?share"
                      target="_blank">
                        <v-icon  size="30px" color="red">
                          mdi-map-marker-outline
                        </v-icon>
                      </v-btn>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Panamá, Panamá </v-list-item-title>
                    <v-list-item-subtitle>PH Plaza Morica,</v-list-item-subtitle>
                    <v-list-item-subtitle>Calle 50, Panamá </v-list-item-subtitle>
                    <v-list-item-subtitle>Piso 9 - Oficina 904 </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
              <v-divider inset></v-divider>
              <div class="text-justify">
                <v-list-item>
                  <v-list-item-icon>
                    <v-btn
                      text
                      href="https://web.whatsapp.com/send?l=es&phone=+50769307666"
                      target="_blank">
                        <v-icon  size="30px" color="green">
                          mdi-whatsapp
                        </v-icon>
                      </v-btn>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>(+507) 6930-7666</v-list-item-title>
                    <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-btn
                      text
                      href="https://web.whatsapp.com/send?l=es&phone=+50769307666"
                      target="_blank">
                        <v-icon  size="30px" color="indigo">
                          mdi-phone
                        </v-icon>
                      </v-btn>
                  </v-list-item-icon>

                  <!-- <v-list-item-content>
                    <v-list-item-title>(+507) 207-4681</v-list-item-title>
                    <v-list-item-title>(+507) 207-4512</v-list-item-title>
                    <v-list-item-subtitle>Work</v-list-item-subtitle>
                  </v-list-item-content> -->
                </v-list-item>
              </div>
              <v-divider inset></v-divider>

              <div class="text-justify">
                <v-list-item>
                  <v-list-item-icon>
                    <v-btn
                      text
                      href="mailto:info@innuvex.com"
                      target="_blank"
                      color="indigo">
                        <v-icon  size="30px" color="blue">
                          mdi-email
                        </v-icon>
                      </v-btn>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title> info@innuvex.com</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-col>
            <v-col cols="12" align-self="justify" sm="12" md="4">
              <v-card-text class="text-justify">
                <div class="text-md-body-1">
                  <v-img
                    :src="require('../../assets/innuvex.png')"
                    transition="scale-transition"
                    max-width="auto"
                    to="/"
                    />
                </div>
                <v-spacer class="pa-4"></v-spacer>
                <p>
                  Somos una empresa panameña dedicada a ofrecer servicios tecnológicos eficientes,
                  soluciones integrales y de alta calidad, utilizando las tecnologías emergentes
                  logramos optimizar los procesos de cualquier tipo de negocio. Nos apasiona lo que hacemos.
                  No somos solo una empresa que vende páginas web, nuestro objetivo es ayudar a nuestros clientes
                  a alcanzar todo su potencial.
                </p>
                </v-card-text>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-card-text class="white--text">
          © {{ new Date().getFullYear() }} Todos los Derechos Resevados. | Diseñado por <strong>Innuvex</strong>
          </v-card-text>

      </v-card>
    </v-card>
</v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: [
      'mdi-facebook',
      'mdi-twitter',
      'mdi-instagram'
    ],
    items: [
      'default',
      'absolute',
      'fixed'
    ],
    padless: true,
    variant: 'default'
  }),
  computed: {
    localAttrs () {
      const attrs = {}

      if (this.variant === 'default') {
        attrs.absolute = true
        attrs.fixed = true
      } else {
        attrs[this.variant] = true
      }
      return attrs
    }
  }
}
</script>
